import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgResveratrolGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M18.8 29.25c2.95-1.95 5.37-4.99 5.37-8.53v-1.88C24.16 12.55 16.93 8 12.06 8H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h2.56v29.71c0 .41.34.75.75.75s.75-.34.75-.75v-7.69c1.47-.14 3.11-.66 4.69-1.5l7.37 9.64c.15.19.37.29.6.29.16 0 .32-.05.46-.15.33-.25.39-.72.14-1.05l-7.27-9.5ZM12.81 9.54c4.15.43 9.86 4.28 9.86 9.3v1.88c0 4.86-5.69 8.85-9.86 9.3V9.54Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M40 30.79c0-5.85-2.33-9.21-6.4-9.21-3.9 0-6.19 3.09-6.38 8.49h-1.75c-.41 0-.75.34-.75.75s.34.75.75.75h1.75c.2 5.37 2.5 8.44 6.38 8.44 3.84 0 5.54-3.4 5.61-3.54.18-.37.03-.82-.35-1a.748.748 0 0 0-1 .34c-.05.11-1.37 2.7-4.26 2.7-3.76 0-4.76-3.61-4.89-6.94h10.54c.41 0 .75-.34.75-.75v-.03Zm-6.4-7.71c3.78 0 4.77 3.64 4.89 6.99h-9.78c.12-3.35 1.11-6.99 4.89-6.99Z",
    fill: "currentColor"
  }));
}

export { SvgResveratrolGlyphSecondary as default };
